import React, {PureComponent} from "react"

import Flex from "@irati/ui/src/Flex"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {OrganisationalSummaryCategory} from "@irati/types"
import FilterChipToggle from "@irati/ui/src/FilterChipToggle"
import theme from "@irati/ui/src/global/theme"

import {TrendTypes} from "./enums"

interface Props extends InjectIntl {
  onChange: (trendRate: TrendTypes) => void,
  isTeamSelected: boolean,
  selectedTrendRate: TrendTypes,
  selectedCategory: OrganisationalSummaryCategory
}


class Categories extends PureComponent<Props> {
  getTrendOptions = () => {
    const {selectedCategory, isTeamSelected} = this.props
    let graphFilters = []

    if (selectedCategory === OrganisationalSummaryCategory.Main) {
      graphFilters = [
        {label: "admin.reporting.orgSummary.main.loginRate.title",
          id: "mainUsersLoggedIn",
          value: TrendTypes.usersLoggedIn},
        {label: "admin.reporting.orgSummary.main.numEngagements.title",
          id: "mainEngagements",
          value: TrendTypes.engagements},
        {label: "admin.reporting.orgSummary.main.savings.title",
          id: "mainSavings",
          value: TrendTypes.savings}
      ]
    }

    if (selectedCategory === OrganisationalSummaryCategory.Perks) {
      graphFilters = [
        {label: "admin.reporting.orgSummary.perks.numUsersRedeemed.title",
          id: "perksUsersRedeemed",
          value: TrendTypes.usersRedeemed},
        {label: "admin.reporting.orgSummary.perks.numRedemptions.title",
          id: "perksRedemptions",
          value: TrendTypes.redemptions},
        {label: "admin.reporting.orgSummary.perks.savings.title",
          id: "perksSavings",
          value: TrendTypes.savings}
      ]
    }
    if (selectedCategory === OrganisationalSummaryCategory.FlexiPerks) {
      graphFilters = [
        {label: "admin.reporting.orgSummary.flexi.numUsersRedeemed.title",
          id: "flexiUsersRedeemed",
          value: TrendTypes.usersRedeemed},
        {label: "admin.reporting.orgSummary.flexi.numRedemptions.title",
          id: "flexiRedemptions",
          value: TrendTypes.redemptions},
        {label: "admin.reporting.orgSummary.flexi.earned.title",
          id: "flexiEarned",
          value: TrendTypes.earned},
        {label: "admin.reporting.orgSummary.flexi.burned.title",
          id: "flexiBurned",
          value: TrendTypes.burned},
        {label: "admin.reporting.orgSummary.flexi.savings.title",
          id: "flexiSavings",
          value: TrendTypes.savings}
      ]
    }
    if (selectedCategory === OrganisationalSummaryCategory.Celebrations) {
      graphFilters = [
        {label: "admin.reporting.orgSummary.celebrations.numUsersEngaged.title",
          id: "celebrationsUsersEngaged",
          value: TrendTypes.usersEngaged},
        {label: "admin.reporting.orgSummary.celebrations.numRecognitions.title",
          id: "celebrationsRecognitions",
          value: TrendTypes.recognitions},
        {label: "admin.reporting.orgSummary.celebrations.numPolls.title",
          id: "celebrationsPolls",
          value: TrendTypes.polls},
        {label: "admin.reporting.orgSummary.celebrations.rewardPointsGiven.title",
          id: "celebrationsRewardPointsGiven",
          value: TrendTypes.rewardPointsGiven},
        {label: "admin.reporting.orgSummary.celebrations.rewardPointsPurchased.title",
          id: "celebrationsRewardPointsPurchased",
          value: TrendTypes.rewardPointsPurchased},
        {label: "admin.reporting.orgSummary.celebrations.usersGivenRecognition.title",
          id: "celebrationsUsersGivenRecognition",
          value: TrendTypes.usersGivenRecognition},
        {label: "admin.reporting.orgSummary.celebrations.usersReceivedRecognition.title",
          id: "celebrationsUsersReceivedRecognition",
          value: TrendTypes.usersReceivedRecognition}
      ]
    }
    if (selectedCategory === OrganisationalSummaryCategory.Wellness) {
      graphFilters = [
        {label: "admin.reporting.orgSummary.wellness.numUsersEngaged.title",
          id: "wellnessUsersEngaged",
          value: TrendTypes.usersEngaged},
        {label: "admin.reporting.orgSummary.wellness.numViews.title",
          id: "wellnessViews",
          value: TrendTypes.views},
        {label: "admin.reporting.orgSummary.wellness.numWebinarRegistrations.title",
          id: "wellnessWebinarRegistrations",
          value: TrendTypes.webinarRegistrations}
      ]
    }

    if (isTeamSelected) {
      return graphFilters
    }

    return [
      {label: "admin.reporting.orgSummary.main.engagementRate.title",
        id: "wellnessEngagmentRate",
        value: TrendTypes.engagementRate},
      ...graphFilters
    ]

  }

  render(){
    const {formatMessage, onChange, selectedTrendRate} = this.props
    const trendOptions = this.getTrendOptions()

    return (
      <Flex direction="column" marginBottom={4} gap={theme.spacing.oneAndHalf}>
        {trendOptions.map((trendRate) =>
          <FilterChipToggle
            id={trendRate.id}
            isToggled={selectedTrendRate === trendRate.value}
            onClick={() => onChange(trendRate.value)}>
            {formatMessage({id: trendRate.label})}
          </FilterChipToggle>
        )}
      </Flex>
    )
  }
}

export default injectIntl(Categories)
